import client from "../../../index";
import {
  GET_PROPERTY_ASSETS,
  GET_PROPERTY_ASSET,
  GET_PROPERTY_ASSET_STATE_COUNTS,
} from "./query";
import {
  CREATE_PROPERTY_ASSET,
  UPDATE_PROPERTY_ASSET,
  DELETE_PROPERTY_ASSET,
  GENERATE_SATELLITE_IMAGE,
} from "./mutation";

const NO_CACHE = "no-cache";

const stripTypenames = (value) => {
  if (value == null || typeof value !== "object") return value;
  if (Array.isArray(value)) return value.map(stripTypenames);
  const { __typename, ...rest } = value;
  return Object.fromEntries(Object.entries(rest).map(([k, v]) => [k, stripTypenames(v)]));
};

const compactObject = (value) =>
  Object.fromEntries(
    Object.entries(value || {}).filter(([, v]) => v !== undefined && v !== null && v !== "")
  );

export const buildPropertyAssetsInput = ({
  filters = {},
  pagination = { page: 1, limit: 25 },
  ordering = { field: "updatedAt", order: "Desc" },
} = {}) =>
  compactObject({
    ...compactObject(filters),
    pagination: pagination ? compactObject(pagination) : undefined,
    ordering: ordering ? compactObject(ordering) : undefined,
  });

export const apiGetPropertyAssetsCollection = async (params = {}) => {
  const input = buildPropertyAssetsInput(params);
  const res = await client.query({
    query: GET_PROPERTY_ASSETS,
    variables: { input },
    fetchPolicy: NO_CACHE,
  });

  return {
    total: res?.data?.propertyAssets?.total || 0,
    items: res?.data?.propertyAssets?.propertyAssets || [],
  };
};

export const apiGetPropertyAsset = async (id) => {
  const res = await client.query({
    query: GET_PROPERTY_ASSET,
    variables: { id },
    fetchPolicy: NO_CACHE,
  });
  return res?.data?.propertyAsset || null;
};

export const apiGetPropertyAssetStateCounts = async ({ domain, authorId } = {}) => {
  const res = await client.query({
    query: GET_PROPERTY_ASSET_STATE_COUNTS,
    variables: { input: compactObject({ domain, authorId }) },
    fetchPolicy: NO_CACHE,
  });
  return res?.data?.propertyAssetStateCounts || [];
};

export const apiCreatePropertyAsset = async (input) => {
  const res = await client.mutate({
    mutation: CREATE_PROPERTY_ASSET,
    variables: { input: stripTypenames(input) },
    fetchPolicy: NO_CACHE,
  });
  return res?.data?.createPropertyAsset?.propertyAsset || null;
};

export const apiUpdatePropertyAsset = async (input) => {
  const res = await client.mutate({
    mutation: UPDATE_PROPERTY_ASSET,
    variables: { input: stripTypenames(input) },
    fetchPolicy: NO_CACHE,
  });
  return res?.data?.updatePropertyAsset?.propertyAsset || null;
};

export const apiDeletePropertyAsset = async (id) => {
  const res = await client.mutate({
    mutation: DELETE_PROPERTY_ASSET,
    variables: { id },
    fetchPolicy: NO_CACHE,
  });
  return res?.data?.deletePropertyAsset?.id || null;
};

export const apiGenerateSatelliteImage = async (input) => {
  const res = await client.mutate({
    mutation: GENERATE_SATELLITE_IMAGE,
    variables: { input: stripTypenames(input) },
    fetchPolicy: NO_CACHE,
  });
  return res?.data?.generateSatelliteImage || null;
};
